export const view_route = {
  "jp-go": {
    title_id: "app.jpgov",
  },
  "jp-lg": {
    title_id: "app.jplg",
  },
  "jp-topix": {
    title_id: "app.topix",
  },
  "jp-bank": {
    title_id: "app.bank",
  },
  "jp-ac": {
    title_id: "app.ac",
  },
  "jp-registrar": {
    title_id: "app.registrar",
  },
  "jp-vce": {
    title_id: "app.vce",
  },
  "jp-jpnic": {
    title_id: "app.jpnic",
  },
};

export const chart_types = {
  "all": {
    title_id: "app.all",
  },
  "jp-go": {
    title_id: "app.jpgov",
  },
  "jp-lg": {
    title_id: "app.jplg",
  },
  "jp-topix": {
    title_id: "app.topix",
  },
  "jp-bank": {
    title_id: "app.bank",
  },
  "jp-ac": {
    title_id: "app.ac",
  },
  "jp-registrar": {
    title_id: "app.registrar",
  },
  "jp-vce": {
    title_id: "app.vce",
  },
  "jp-jpnic": {
    title_id: "app.jpnic",
  },
}

export const check_types = {
  "ds": {
    title: "DNSSEC"
  },
  "spf": {
    title: "SPF"
  },
  "dkim": {
    title: "DKIM"
  },
  "dmarc": {
    title: "DMARC"
  },
  "caa": {
    title: "CAA"
  },
  "mta-sts": {
    title: "MTA-STS"
  },
  "bimi": {
    title: "BIMI"
  }
}

export const results_path = "/results";
export const app_root_path = "/";

export const brand = "dnsops.jp";
export const brand_url = "https://dnsops.jp/";
